module.exports = __webpack_public_path__ + "img/bgrnd7.f58fc8f3.jpg";